import { Button } from "@material-tailwind/react";
import React from "react";
import { useNavigate } from "react-router-dom";

function AllReceiptButton({ id }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/home/receipts/view/${id}`);
  };

  return (
    <Button color="blue-gray" fullWidth onClick={handleClick}>
      View Receipt
    </Button>
  );
}

export default AllReceiptButton;
